import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'base-table',
  templateUrl: './base-table.component.html',
  styleUrls: ['./base-table.component.css']
})
export class BaseTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  getPlayerImage(id: number) {
    return "/assets/images/players/" + id.toString() + ".jpg";
  }

  getDefaultImage(event) {
    event.target.src = '/assets/images/players/default.jpg';
  }

  getPlayerFlag(country: string) {
    return "/assets/images/countries/" + country.toString() + ".png";  
  }

}
